export const SESSION_ID = 'sessionId';
export const MENU_IS_COLLAPSED = 'menuIsCollapsed';
export const BANNERS_HEIGHT = 'bannersHeight';
export const OPENED_FOLDERS = 'openedFolders';
export const CUSTOMIZE_DASHBOARD_PANEL_IS_CLOSE = 'customizeDashboardPanelIsClose';
export const POSTHOG_INITIATED = 'posthogInitiated';
